import { Duration } from 'dayjs/plugin/duration.js';
import { TimeZone } from '../../time/timezone.js';
import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../dto/dto.js';

export class DurationRange extends DataModel {
  static readonly TYPE_ID: string = 'ef08016bc4664d4fb9cdc791b61c4328';

  private constructor(
    public readonly from: Duration,
    public readonly to: Duration,
  ) {
    super();
  }

  get isExact(): boolean {
    return this.from.asMilliseconds() === this.to.asMilliseconds();
  }

  get $typeId(): string {
    return DurationRange.TYPE_ID;
  }

  static between(from: Duration, to: Duration): DurationRange {
    return new DurationRange(from, to);
  }

  static exactly(duration: Duration): DurationRange {
    return new DurationRange(duration, duration);
  }

  static fromMap(context: SerializationContext, map: SerializedData): DurationRange {
    return new DurationRange(
        context.decodeDuration(MapUtils.get<number>(map, 'from')),
        context.decodeDuration(MapUtils.get<number>(map, 'to')),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'from': context.encodeDuration(this.from),
      'to': context.encodeDuration(this.to),
    };
  }

  clone(): this {
    return new DurationRange(
        TimeZone.cloneDuration(this.from),
        TimeZone.cloneDuration(this.to),
    ) as this;
  }

  isSame(other: DurationRange): boolean {
    if(this === other) {
      return true;
    }

    return other.from === this.from && other.to === this.to;
  }
}

export class DurationRangeBuilder extends DataModelBuilder<DurationRange> {
  build(context: SerializationContext, map: SerializedData): DurationRange {
    return DurationRange.fromMap(context, map);
  }
}
